import axios from 'axios';
import * as actionTypes from './actionTypes';
import apiCall from '../app/apiCall.js';
import { LANGUAGE } from './../constants';
import { getBidSessionsUrl } from '../../utilities/helpers';

let commonLabels;
if (sessionStorage.getItem(LANGUAGE.LANG_KEY) === LANGUAGE.FRENCH) {
  commonLabels = require('./../../labels/labels.french.json').commonLabels;
} else {
  commonLabels = require('./../../labels/labels.json').commonLabels;
}
export function getLanguage(staffId) {
  return () => {
    const languageUrl = `profiles/${staffId}`;
    apiCall(languageUrl, 'get').then(response => {
      sessionStorage.setItem(
        LANGUAGE.LANG_KEY,
        response.data.language && response.data.language.code
          ? response.data.language.code
          : null
      );
      window.location.reload();
    });
  };
}

export const fetchHomeRequest = () => ({
  type: actionTypes.FETCH_HOME_REQUEST
});
export const fetchHomeFailure = message => ({
  type: actionTypes.FETCH_HOME_FAILURE,
  message
});
export const fetchHomeSuccess = home => ({
  type: actionTypes.FETCH_HOME_SUCCESS,
  home
});

export function fetchHome(staffId) {
  return dispatch => {
    dispatch(fetchHomeRequest());

    function insertLastSavedDate(openBids, user, messages = []) {
      const requests = [];
      openBids.entries.forEach(bid => {
        const getLastSavedDateUrl = `preferences/bid-session/${bid.bidSessionId}/employee/${staffId}/last-revision`;
        requests.push(apiCall(getLastSavedDateUrl));
      });
      axios
        .all(requests)
        .then(
          axios.spread((...params) => {
            openBids.entries.forEach((bid, key) => {
              bid.lastSaved = params[key].data.lastSave
                ? params[key].data.lastSave
                : null;
            });
            return dispatch(fetchHomeSuccess({ user, messages, openBids }));
          })
        )
        .catch(e => {
          let exceptionMsg = e;
          if (e && e.response && e.response.data && e.response.data.message) {
            exceptionMsg = e.response.data.message;
          }
          dispatch(fetchHomeFailure(exceptionMsg));
        });
    }

    function getNotesAndBids(user) {
      if (Object.keys(user).length > 0) {
        const isAdminLogged = user.staffId === commonLabels.ADMIN;

        // Use appropriate bid sessions endpoint based on admin impersonation status
        const getOpenBidsUrl = getBidSessionsUrl();

        const categoryId = isAdminLogged ? 0 : user.currentCategory.categoryId;
        const openBidsData = {
          categoryId
        };

        if (isAdminLogged) {
          apiCall(getOpenBidsUrl, 'post', openBidsData)
            .then(respOpenBids => {
              const openBids = respOpenBids.data;
              insertLastSavedDate(openBids, user);
            })
            .catch(e => dispatch(fetchHomeFailure(e.response.data.message)));
        } else {
          const getNotesAndMessagesUrl = `employees/planner_notes/${categoryId}`;
          axios
            .all([
              apiCall(getNotesAndMessagesUrl),
              apiCall(getOpenBidsUrl, 'post', openBidsData)
            ])
            .then(
              axios.spread((respMessage, respOpenBids) => {
                const messages = respMessage.data;
                const openBids = respOpenBids.data;
                insertLastSavedDate(openBids, user, messages);
              })
            )
            .catch(e => {
              let exceptionMsg = e;
              if (e && e.response && e.response.data && e.response.data.message) {
                exceptionMsg = e.response.data.message;
              }
              dispatch(fetchHomeFailure(exceptionMsg));
            });
        }
      }
    }

    function getUserInformation() {
      const userRequestUrl = `employees/${staffId}`;
      apiCall(userRequestUrl)
        .then(response => {
          const user = response.data;
          getNotesAndBids(user);
        })
        .catch((e) => {
          let exceptionMsg = e;
          if (e && e.response && e.response.data && e.response.data.message) {
            exceptionMsg = e.response.data.message;
          }
          dispatch(fetchHomeFailure(exceptionMsg));
        });
    }
    getUserInformation();
  };
}
